export default "__VITE_ASSET__CGkkIRFj__"